module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/map-e8fea92144f8a15e06fb2714f4a6ad17.png";